import React, { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Text } from '@/components/Typography';
import { Success } from './Success';
import { Loading } from './Loading';
import * as S from './styles';

interface EditActionPlanProps {
	onClickDelete(): void;
	isLoading: boolean;
	onClick(): void;
}

export function EditActionPlan({ isLoading, onClick, onClickDelete }: Readonly<EditActionPlanProps>) {
	const [isGenerating, setIsGenerating] = useState<boolean>(true);

	function handleTimeout(): void {
		setTimeout(() => {
			setIsGenerating(false);
		}, 1000);
	}

	useEffect(() => {
		if (!isLoading) {
			handleTimeout();
		}
	}, [isLoading]);

	return (
		<Col span={12} style={{ paddingBottom: '10px' }}>
			<Row justify="center">
				<S.SpinnerContainer span={24}>{isGenerating ? <Loading /> : <Success />}</S.SpinnerContainer>
			</Row>
			<Row justify="center" gutter={[20, 0]}>
				<Col span={12}>
					<S.EditButton onClick={onClick}>
						<Text>{I18n.get('Edit action plan')}</Text>
					</S.EditButton>
				</Col>
				<Col span={12}>
					<S.DeleteButton onClick={onClickDelete}>{I18n.get('Delete action plan')}</S.DeleteButton>
				</Col>
			</Row>
		</Col>
	);
}
